import React from 'react';
import ABTesting from '../a-b-testing/ABTesting';
import useCurrentLanguage from '../../i18n/useCurrentLanguage';
import { isProdBuild } from '../../i18n/environments';
import stickyHighlightStripA from './stickyHighlightStripA';
import stickyHighlightStripB from './stickyHighlightStripB';

const StickyHighlightStripAB = (props) => {
  const { isEs } = useCurrentLanguage();

  const testConfig = {
    testId: isProdBuild ? 'ee38ccbc-dc7d-4557-81c0-5447b2848af0' : 'c174d0e5-e842-42f8-966e-50cfa95c1858',
    abPages: [stickyHighlightStripA, stickyHighlightStripB],
    defaultVersion: stickyHighlightStripA,
    startDate: '2025-01-20',
    endDate: '2026-01-20',
    url: isEs ? `/es/${props.pageUrl}/` : `/${props.pageUrl}/`,
  };
  return <ABTesting {...testConfig} {...props} language={isEs} />;
};

export default StickyHighlightStripAB;
